import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { getText, getMedia, trackGA } from 'misc/helpers';

class AgreementView extends Component {
    render = () => {
        const { agreement, location } = this.props;

        // Get back url 
        const path = location.pathname.split('agreement');
        let backUrl = path[1];

        // Get Agreement cms key from store
        let agreementCmsKey = undefined;
        if (agreement.data && agreement.data[0]) {
            agreementCmsKey = agreement.data[0].cmsKey;
        }

        return (
            <div className="main-layout">
                <div className="main-content">
                    <Link to={backUrl}>
                        <div className="agreement-back-link">
                            <img src="assets/images/agreement/back_arrow.svg" alt="" /> <span>{getText('_1_3_TextBack', 'Tillbaka')}</span>
                        </div>
                    </Link>
                    <div className="agreement-viewer">
                        <div className="agreement-document">
                            <iframe title="Content" src={getMedia(agreementCmsKey)} frameBorder="0" scrolling="no" width="100%" height="100%" id="iframe" />
                        </div>
                    </div>
                    <img className="logo-bottom-left" src="assets/images/digimail_logo_yellow.svg" alt="" />
                </div>
            </div>
        );
    };


    componentDidMount() {
        trackGA('2.3 Villkor');
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        agreement: state.agreement
    };
};

export default connect(mapStateToProps)(AgreementView);



// WEBPACK FOOTER //
// ./src/components/views/AgreementView.js